<app-main-toolbar *ngIf="user"></app-main-toolbar>
<router-outlet></router-outlet>
<app-footer></app-footer>
